(() => {
  if (window.PhoenixCartEssentials) return;
  window.PhoenixCartEssentials = true;

  const addButtonSelector = '[data-phoenix-cart-add]';
  const drawerRemoveSelector = '#CartDrawer .cart__remove a[href*="/cart/change"]';
  const drawerTriggerSelector = '.js-drawer-open-cart[aria-controls="CartDrawer"]';

  const drawer = document.querySelector('#CartDrawer');
  if (drawer) {
    const drawerTriggers = [...document.querySelectorAll(drawerTriggerSelector)];
    let drawerReturnFocus = null;
    let drawerWasOpen = drawer.classList.contains('drawer--is-open');
    const drawerTitle = drawer.querySelector('.drawer__title');
    if (drawerTitle) {
      if (!drawerTitle.id) drawerTitle.id = 'CartDrawerTitle';
      drawer.setAttribute('aria-labelledby', drawerTitle.id);
    }

    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');

    const syncDrawerVisibility = () => {
      const isOpen = drawer.classList.contains('drawer--is-open');
      drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      drawerTriggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      if (!isOpen && drawerWasOpen) {
        const focusTarget = drawerReturnFocus || drawerTriggers[0];
        window.setTimeout(() => {
          if (!drawer.classList.contains('drawer--is-open') && focusTarget?.isConnected) {
            focusTarget.focus();
          }
        }, 550);
      }

      drawerWasOpen = isOpen;
    };

    document.addEventListener(
      'click',
      (event) => {
        const trigger = event.target.closest(drawerTriggerSelector);
        if (trigger) drawerReturnFocus = trigger;
      },
      true
    );

    syncDrawerVisibility();
    new MutationObserver(syncDrawerVisibility).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  document.addEventListener('click', async (event) => {
    const removeLink = event.target.closest(drawerRemoveSelector);
    if (!removeLink) return;

    const item = removeLink.closest('.cart__item');
    const key = item?.dataset.key;
    if (!key || item.getAttribute('aria-busy') === 'true') return;

    event.preventDefault();
    item.setAttribute('aria-busy', 'true');

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: key,
          quantity: 0,
        }),
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.description || result.message);
      }

      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart: result },
        })
      );
    } catch (error) {
      item.removeAttribute('aria-busy');
      window.location.assign(removeLink.href);
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(addButtonSelector);
    if (!button || button.disabled) return;

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const status = button
      .closest('.phoenix-cart__upsells')
      ?.querySelector('[data-phoenix-cart-status]');
    const addLabel = button.dataset.addLabel || button.textContent.trim();
    const addingLabel = button.dataset.addingLabel || addLabel;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = addingLabel;
    if (status) status.textContent = '';

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.description || result.message || 'Unable to add this item.');
      }

      document.dispatchEvent(new CustomEvent('cart:build'));
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = addLabel;
      if (status) status.textContent = error.message;
    }
  });
})();
